import { Chain } from "@thirdweb-dev/chains";

export const base: Chain = {
  name: "Base Mainnet",
  chain: "BASE",
  rpc: ["https://mainnet.base.org"],
  nativeCurrency: {
    name: "Ethereum",
    symbol: "ETH",
    decimals: 18,
  },
  shortName: "base",
  slug: "base",
  testnet: false,
  chainId: 8453,
  icon: {
    url: "chain-logos/base.svg",
    width: 32,
    height: 32,
    format: "svg",
  },
};

export const pulsechain: Chain = {
  name: "PulseChain Mainnet",
  chain: "PLS",
  rpc: ["https://rpc.pulsechain.com"],
  nativeCurrency: {
    name: "PulseChain",
    symbol: "PLS",
    decimals: 18,
  },
  shortName: "pls",
  slug: "pulsechain",
  testnet: false,
  chainId: 369,
  icon: {
    url: "chain-logos/pulsechain.svg",
    width: 32,
    height: 32,
    format: "svg",
  },
};

export const supportedChains = [base, pulsechain];

export const chainConfigs = [
  { id: "ethereum", name: "Ethereum", price: "0.1 ETH", chainId: 1 },
  { id: "base", name: "Base", price: "0.01 ETH", chainId: 8453 },
  { id: "pulsechain", name: "PulseChain", price: "1000 PLS", chainId: 369 },
  { id: "chia", name: "Chia", price: "0.1 XCH", chainId: null },
];